function adaBanner() {
    const bannerContainer = document.querySelector(".leadflex-ada-banner");

    if (!bannerContainer) {
        return;
    }

    const header = bannerContainer.querySelector(".leadflex-ada-banner__header");
    const body = bannerContainer.querySelector(".leadflex-ada-banner__content");
    const button = bannerContainer.querySelector(".leadflex-ada-banner__button-container > button");

    // Initially collapse the content by setting the max-height to 0
    body.style.maxHeight = "0px";

        // Add click event to toggle the active class
    button.addEventListener("click", () => {
        const isActive = bannerContainer.classList.contains("active");

        // Toggle 'active' class on the container
        if (isActive) {
            body.style.maxHeight = "0px";
            bannerContainer.classList.remove("active");
            button.innerHTML="See More";
        } else {
            body.style.maxHeight = `${body.scrollHeight}px`;
            bannerContainer.classList.add("active");
            button.innerHTML="See Less";

            // Delay the scroll into view to ensure it happens after the content has expanded
            setTimeout(() => {
                body.scrollIntoView({ behavior: "smooth" });
            }, 300);
        }
    });
}

export default adaBanner();
